import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AccountInfo } from '@azure/msal-browser';
import { AppService } from '../../../service/app.service';
import { MsalService } from '@azure/msal-angular';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, MatToolbarModule],
  templateUrl: './header.component.html',

})
export class HeaderComponent {
  @Input('user') user: AccountInfo | null = null;
  isAdmin: boolean = this.appService.user.isUtenteAdmin ?? false;
  utente = this.appService.user;

  constructor(
    private router: Router,
    private appService: AppService,
    private authService: MsalService,
  ) { }

  redirect(url:string) {
    this.router.navigate([url]);
  }

  logout() {
    this.authService.logoutRedirect();
  }
}
